import InfiniteScroll from 'react-infinite-scroller';
import { ChatInput } from '../ChatInput';
import React from 'react';
import MessageList from '../MessageList';
import { MessageListWrapper } from '../style';
import { useSession } from '@lendi/lala-react';
import CommPanelLoader from '../../Loader';
import { useChatOpenTracking } from '../../../analytics';
export var RestrictedTeamViewChat = function (_a) {
    var _b;
    var _c = _a.restrictedViewResponse, messages = _c.messages, nextPage = _c.nextPage, fetchNextPage = _a.fetchNextPage, restrictedViewLoading = _a.restrictedViewLoading;
    var session = useSession();
    var displayRef = React.useRef(null);
    var scrollToBottom = function () {
        if (displayRef && displayRef.current && displayRef.current.scrollIntoView) {
            displayRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
        }
    };
    React.useEffect(scrollToBottom, []);
    var hasMoreItems = nextPage.pageNumber !== null;
    useChatOpenTracking(false);
    return restrictedViewLoading ? (React.createElement(CommPanelLoader, null)) : (React.createElement(React.Fragment, null,
        React.createElement(MessageListWrapper, null,
            React.createElement(InfiniteScroll, { pageStart: 0, loadMore: fetchNextPage, hasMore: hasMoreItems, isReverse: true, initialLoad: false, useWindow: false },
                React.createElement(MessageList, { identity: (_b = session === null || session === void 0 ? void 0 : session.identity) === null || _b === void 0 ? void 0 : _b.id, members: [], messages: messages, userType: 'broker' }),
                React.createElement("div", { ref: displayRef }))),
        React.createElement(ChatInput, { value: "You are not the member of this channel, so you can't communicate.", disabledSend: true, disabledTextArea: true, send: function () { }, onKeyDown: function () { }, onChange: function () { } })));
};
//# sourceMappingURL=index.js.map